import "./ShareYourStory.module.css";
import Header from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import BenefitsOfStorytelling from "./sections/BenefitsOfStorytelling";
import StorySubmissionForm from "./sections/StorySubmissionForm";
import GuidelinesResources from "./sections/GuidelinesResources";
import Article from "./sections/Article";
import Faq from "./sections/Faq";
import FooterIntelligence from "@/reusable_sections/Footer";
export default function ShareYourStoryPage() {
  return <div>
      <Header />
      <ServicesOverview />
      <BenefitsOfStorytelling />
      <StorySubmissionForm />
      <GuidelinesResources />
      <Article />
      <Faq />
      <FooterIntelligence />
    </div>;
}